import { DateTime } from 'luxon'

const statusObject = {
  1: 'Aprovado',
  2: 'Não Aprovado',
  3: 'Revisão',
  4: 'Não Reportado',
  5: 'Processando',
  8: 'Falha na Recorrência',
  9: 'Criado',
  10: 'Inativa',
  11: 'Aguardando Pagamento',
  12: 'Expirado',
  13: 'Pago',
}

const periodType = {
  daily: 'Diário',
  weekly: 'Semanal',
  monthly: 'Mensal',
  bimonthly: 'Bimestral',
  quarterly: 'Trimestral',
  semiannual: 'Semestral',
  annual: 'Anual',
}

const regexDate = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/
const regexValue = /^R\$\s(\d{1,3}(\.\d{3})*|\d+)(\,\d{2})?$/

const formatter = new Intl.NumberFormat('pt-br', {
  style: 'currency',
  currency: 'BRL',
})

export const reciepTransaction = data => {
  const { name } = data.product
  let { status } = data.link
  const tax_id =  data.payment.payer_tax_id || ''
  const {
    installments,installments_selected, transaction_date, nsu, authorization_code, value,
  } = data.payment

  const { soft_descriptor, merchant_name } = data.user

  status = typeof (status) === 'object' ? status.code : status
  status = statusObject[status]

  const dataTransaction = [
    {
      title: 'Estabelecimento',
      message: merchant_name || soft_descriptor,
    },
    {
      title: 'Produto',
      message: name,
    },
    {
      title: 'Status',
      message: status,
    },
    {
      title: tax_id.length === 14 ? 'CPF' : tax_id.length === 18 ? 'CNPJ' : 'Documento',
      message: tax_id || null,
    },
    {
      title: 'Parcelas',
      message: installments_selected,
    },
    {
      title: 'NSU',
      message: nsu,
    },
    {
      title: 'Autorização',
      message: authorization_code,
    },
    {
      title: 'Data da Venda',
      message: transaction_date === 'Invalid DateTime' ? null : regexDate.test(transaction_date) ? transaction_date : DateTime.fromISO(transaction_date).toFormat(
        'dd/MM/yyyy',
      ),
    },
    {
      title: 'Valor da Venda',
      message: regexValue.test(value) ? value : formatter.format(value),
    },
  ].filter(dataMessage => !!dataMessage.message)

  return dataTransaction
}

export const reciepRecurrence = data => {
  const { name } = data.product
  let { status } = data.link
  const { tax_id } = data.customer
  const {
    period, value, next_date,
  } = data.payment

  const { soft_descriptor } = data.user

  status = typeof (status) === 'object' ? status.code : status
  status = statusObject[status]

  const dataRecurrence = [
    {
      title: 'Estabelecimento',
      message: soft_descriptor,
    },
    {
      title: 'Produto',
      message: name,
    },
    {
      title: 'Status',
      message: status,
    },
    {
      title: 'Tipo',
      message: 'Recorrência',
    },
    {
      title: tax_id.length === 14 ? 'CPF' : tax_id.length === 18 ? 'CNPJ' : 'Documento',
      message: tax_id,
    },
    {
      title: 'Período',
      message: periodType[period] ? periodType[period] : period,
    },
    {
      title: 'Próxima Cobrança',
      message: regexDate.test(next_date) ? next_date : DateTime.fromISO(next_date).toFormat(
        'dd/MM/yyyy',
      ),
    },
    {
      title: 'Valor da Cobrança',
      message: regexValue.test(value) ? value : formatter.format(value),
    },
  ]

  return dataRecurrence
}
